var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Link } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { CanvasWithCenterImage } from '@lean-body/src/view/atoms/canvas_with_center_image';
import { TwitterEllipseButton } from '@lean-body/src/view/molecules';
import { useXlMediaQuery } from '@lean-body/src/util';
export const CenterImageWidthForBadge = (badge, isXL) => {
    return badge.isChallenge ? 130 : isXL ? 120 : 100;
};
export const BadgeDialog = ({ imgWidth, imgHeight, title, description, linkTo, linkText, badge, twitterService, onClickTwitterShareIfAuthed, sharedTiming, }) => {
    const isXL = useXlMediaQuery();
    const canvas = React.useRef();
    if (!badge)
        return null;
    const imgSrc = badge.completeImageURL;
    const centerImageWidth = CenterImageWidthForBadge(badge, isXL);
    const defaultTweetText = badge.isChallenge
        ? `LEAN BODYで『${badge.name}』を全てクリアしました！ #リーンボディ #LEANBODY`
        : `LEAN BODYで『${badge.name}』を達成してバッジをGETしました！ #リーンボディ #LEANBODY`;
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        yield twitterService.onClickShareForBadgeOrRank(imgSrc, centerImageWidth, defaultTweetText, sharedTiming, badge);
        if (twitterService.isAuthorized)
            onClickTwitterShareIfAuthed();
    });
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(CanvasWithCenterImage, { ref: canvas, imgSrc: imgSrc, width: imgWidth, height: imgHeight, centerImageWidth: centerImageWidth, classObject: styles.canvas }),
        React.createElement("div", { className: css(styles.itemsColumn) },
            React.createElement("div", { className: css(styles.textContainer) },
                React.createElement("div", { className: css(styles.title) }, title),
                description && React.createElement("div", { className: css(styles.description) }, description)),
            React.createElement(TwitterEllipseButton, { classObject: styles.shareButton, text: 'ポストする', onClick: onClick }),
            linkText && linkTo && (React.createElement(Link, { className: css(styles.link), to: linkTo }, linkText)))));
};
const styles = StyleSheet.create({
    container: {
        textAlign: 'center',
        display: 'block',
        borderRadius: 8,
        overflow: 'hidden',
    },
    itemsColumn: {
        padding: '16px 18px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        alignItems: 'center',
    },
    textContainer: {
        marginBottom: 16,
    },
    title: {
        whiteSpace: 'pre-wrap',
        fontSize: 20,
        fontWeight: 'bold',
        [MediaBreakPointUp.XL]: {
            fontSize: 24,
        },
    },
    description: {
        fontSize: 14,
        fontWeight: 400,
        marginTop: 8,
        whiteSpace: 'pre-wrap',
        [MediaBreakPointUp.XL]: {
            fontSize: 16,
        },
    },
    descriptionBold: {
        fontWeight: 'bold',
    },
    link: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        color: Colors.PrimaryDarkB,
        marginTop: 10,
        padding: '16px 0',
        display: 'block',
        [MediaBreakPointUp.XL]: {
            fontSize: 20,
            padding: '11px 0',
        },
    },
    canvas: {
        borderRadius: '8px 8px 0 0',
    },
    shareButton: {
        width: '100%',
        [MediaBreakPointUp.XL]: {
            width: 320,
        },
    },
});
